import axiosInstance from 'app/modules/shared/api/axiosInstance';

export const ChatComponentAPI = {
    getLinesByScope: (company, factory) =>
        axiosInstance.get(
            `${company}/${factory}/productionLines/by-user-scopes`
        ),
};
